import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Divider, Input, Typography } from 'antd';
import { useCurrentUser } from '../../../../context/UserContext';
import { useMfaSetupData, useVerifyMfa } from '../../../../hooks/useAuth';
import { AuthLayout } from '../../components/Layout';

export const PageMFASetup = () => {
    const navigate = useNavigate();
    const { mfaSecretExists } = useCurrentUser();
    const [mfaToken, setMfaToken] = useState('');
    const setupData = useMfaSetupData();
    const verify = useVerifyMfa();

    useEffect(() => {
        if (mfaSecretExists) {
            navigate('/');
        } else {
            setupData.mutate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mfaSecretExists]);

    const onMFATokenChange = (e) => setMfaToken(e.target.value);

    const onVerify = () => {
        const payload = { token: mfaToken };
        if (setupData.data?.secret) payload.secret = setupData.data.secret;
        verify.mutate(payload);
    };

    const error = setupData.error || verify.error;

    return (
        <AuthLayout
            mainBoxClass='mfa-setup'
            error={error}
            heading='Set up two-factor auth'
            subheading='Scan the QR code with your authenticator app, then confirm the 6-digit code below.'
        >
            <Typography.Title level={4}>Two-Factor Authentication (2FA)</Typography.Title>
            <Divider />
            <Typography.Title level={5}>Configuring Google Authenticator or Authy</Typography.Title>
            <div>
                <li>Install Google Authenticator (IOS - Android) or Authy (IOS - Android).</li>
                <li>In the authenticator app, select &quot;+&quot; icon.</li>
                <li>
                    Select &quot;Scan a barcode (or QR code)&quot; and use the phone&apos;s camera to scan this barcode.
                </li>
            </div>
            <Divider />
            <Typography.Title level={5}>Scan QR Code</Typography.Title>
            <div style={{ textAlign: 'center' }}>
                {setupData.data?.qrCode ? <img src={setupData.data.qrCode} alt='QR Code' /> : null}
            </div>
            <Divider />
            <Typography.Title level={5}>Or Enter Code Into Your App</Typography.Title>
            <div>Secret key: {setupData.data?.secret}</div>
            <Divider />
            <Typography.Title level={5}>Verify Code</Typography.Title>
            <div>For changing the setting, please verify the authentication code:</div>
            <Input
                onChange={onMFATokenChange}
                placeholder='Enter code (XXXXXX)'
                inputMode='numeric'
                autoComplete='one-time-code'
            />
            <Divider />
            <Button
                onClick={onVerify}
                size='large'
                type='primary'
                htmlType='submit'
                loading={verify.isPending}
                className='login-form-button'
            >
                Verify &amp; Activate
            </Button>
        </AuthLayout>
    );
};
